<template>
  <div class="row loyalty-store-campaigns-page">
    <div class="col-md-12 col-lg-12">
      <div class="search-bar">
        <div class="col-sm-12 no-padding">
          <div class="pull-left">
            <el-input v-model="filters[0].value" :placeholder="$t('reports.search')" class="icon-search"></el-input>
          </div>
          <div class="pull-right">
            <router-link
              class="btn add"
              :title="$t('general.add') + ' ' + $t('pages.loyaltyStoreCampaigns')"
              :to="{ path: '/marketing/loyalty-store-campaigns/add' }"
            >
              <img src="/static/img/icons/add.png">
              {{ $t('general.add') }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-content row">
          <data-tables
            ref="loyaltyStoreDataTables"
            class="campaign-table width-table loyalty-store-campaigns-table"
            v-loading="loading"
            :data="tableData"
            :action-def="defaultActionDef()"
            :pagination-def="paginationDef"
            :table-props="{ border: false }"
            :filters="filters"
            @row-click="goToRecord"
            style="width: 100%"
          >
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="70"
              prop="id"
              :label="$t('customers.id')"
            />
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="160"
              prop="name"
              :label="$t('loyaltyStore.campaignName')"
            />
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="180"
              :label="$t('loyaltyStore.availability')"
            >
              <template slot-scope="props">
                {{ formatAvailabilityRange(props.row) }}
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="100"
              :label="$t('loyaltyStore.rewardsCount')"
            >
              <template slot-scope="props">
                {{ props.row.rewards_count != null ? props.row.rewards_count : (props.row.rewards ? props.row.rewards.length : 0) }}
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="90"
              :label="$t('loyaltyStore.active')"
            >
              <template slot-scope="props">
                <p-switch
                  :value="!!props.row.active"
                  type="success"
                  @input="(val) => handleActive(props.row, val)"
                />
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :width="120"
              prop="actions"
              :label="$t('marketingCampaigns.actions')"
            >
              <template slot-scope="props">
                <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                  <span class="arrow-box">&#9662;</span>
                  <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item @click.native.stop="editRecord(props.row)">
                      {{ $t('general.edit') }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native.stop="handleDelete(props.row)">
                      {{ $t('general.delete') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import DataTables from 'vue-data-tables'
import swal from 'sweetalert2'
import PSwitch from 'src/components/UIComponents/Switch.vue'

Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(DataTables)

export default {
  components: { PSwitch },
  props: {
    isLoyaltyStoreCampaigns: { type: Boolean, default: false }
  },
  watch: {
    isLoyaltyStoreCampaigns (v) {
      if (v) this.initPage()
    },
    tableData () {
      this.$nextTick(() => this.layoutTable())
    }
  },
  data () {
    return {
      loading: false,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      filters: [{ value: '', prop: ['name', 'id'] }],
      tableData: []
    }
  },
  created () {
    this.$bus.$on('refresh', this.handleRefresh)
  },
  mounted () {
    this.initPage()
    this._onResizeTable = () => this.layoutTable()
    window.addEventListener('resize', this._onResizeTable)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
    if (this._onResizeTable) {
      window.removeEventListener('resize', this._onResizeTable)
    }
  },
  methods: {
    handleRefresh () {
      this.initPage()
    },
    layoutTable () {
      const dt = this.$refs.loyaltyStoreDataTables
      const elTable = dt && dt.$refs && dt.$refs.elTable
      if (elTable && typeof elTable.doLayout === 'function') {
        elTable.doLayout()
      }
    },
    goToRecord (row, column, event) {
      if (column && column.property === 'actions') return
      this.editRecord(row)
    },
    editRecord (row) {
      if (!row || !row.id) return
      this.$router.push('/marketing/loyalty-store-campaigns/edit/' + row.id)
    },
    formatAvailabilityRange (row) {
      const dash = this.$t('general.emDash') || '—'
      const from = row.starts_at || null
      const to = row.ends_at || null
      if (!from && !to) return dash
      const a = from ? this.formatDate(from) : dash
      const b = to ? this.formatDate(to) : dash
      return `${a} - ${b}`
    },
    normalizeList (response) {
      if (!response || !response.data) return []
      const d = response.data
      if (Array.isArray(d)) return d
      if (Array.isArray(d.data)) return d.data
      return []
    },
    initPage () {
      this.loading = true
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/loyalty-store-campaigns', 'GET', data, (response) => {
        if (response.status) {
          this.tableData = this.normalizeList(response)
        } else {
          swal('', this.$t('validations.wentWrong'), 'error')
        }
        this.loading = false
        this.$nextTick(() => this.layoutTable())
      })
    },
    handleActive (row, val) {
      const previous = !!row.active
      row.active = val
      const body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: val ? 1 : 0
      }
      this.apiRequest('/loyalty-store-campaigns/' + row.id, 'PUT', body, (response) => {
        if (!response.status) {
          row.active = previous
          swal('', this.$t('validations.wentWrong'), 'error')
        }
      })
    },
    handleDelete (row) {
      swal({
        title: this.$t('loyaltyStore.deleteConfirmation'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then((result) => {
        if (result !== true && !(result && result.value === true)) return
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/loyalty-store-campaigns/' + row.id, 'DELETE', data, (response) => {
          if (response.status) {
            this.initPage()
            swal('', this.$t('general.success'), 'success').catch(() => {})
          } else {
            swal('', this.$t('validations.wentWrong'), 'error')
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
/* Global rule hides pagination inside .campaign-table — show it for this page */
.loyalty-store-campaigns-page >>> div.campaign-table div.pagination-bar {
  display: block !important;
}
</style>

<style>
/* Keep the theme's cell backgrounds aligned across text, switches and actions. */
.loyalty-store-campaigns-page .loyalty-store-campaigns-table.campaign-table .el-table tbody .cell {
  height: 55px !important;
  min-height: 55px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  line-height: 1.3 !important;
}

.loyalty-store-campaigns-page .loyalty-store-campaigns-table.campaign-table .el-table td {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.loyalty-store-campaigns-page .centered-cell .cell {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

.loyalty-store-campaigns-page .arrow-box {
  display: inline-block;
  font-size: 18px;
  padding: 4px 6px;
  border: 1px solid #674BD2 !important;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2;
}

.loyalty-store-campaigns-page .arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important;
}

.loyalty-store-campaigns-page .custom-dropdown-menu {
  min-width: 160px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/LoyaltyStore/LoyaltyStoreCampaigns.vue